module.exports = __webpack_public_path__ + "static/media/1POLICY30.dea53703.jpg";